export default __webpack_public_path__ + "static/footer-statrys-logo-3ba345923e538843eaee53aab3a87b07.svg";